import axios from "axios";
import qs from "qs";
//将所有的主机名和端口 一起设置
// axios.defaults.baseURL = "crmapi.kidcastle.org";
import Urls from "../../urlLink";
const root = Urls.crmApiUrl; //域名
//首页数据请求
const url = {
  getSource: root + "/Public/getSourceApi",
  getMarketer: root + "/Public/getMarketerApi",
  getIntentCourse: root + "/Public/getIntentCourseApi",
  addClient: root + "/Client/addClientAction",
  getclientOne: root + "/Client/clientOneApi",
  getclientOneTrack: root + "/Client/clientOneTrackApi",
  getFriendRelation: root + "/Public/getFriendRelationApi",
  addallotClient: root + "/Client/allotClientApi",
  getclientOneInvite: root + "/Client/clientOneInviteApi",
  getclientOneAudition: root + "/Client/clientOneAuditionApi",
  getCommode: root + "/Public/getCommodeApi",
  getObjectApi: root + "/Api/getObjectApi", //获取沟通对象
  getTraceNote: root + "/Public/getTraceNoteApi",
  settingtrackClient: root + "/Client/trackClientAction",
  editClient: root + "/Client/editClientAction",
  getClientName: root + "/Client/getClientNameApi",
  bindingClient: root + "/Client/bindingClientAction",
  getBindingClient: root + "/Client/getBindingClientApi",
  delFamilyRelation: root + "/Public/delFamilyRelationApi",
  delIntentionSource: root + "/Public/delIntentionSourceApi",
  getReceiverList: root + "/Api/getReceiverList",
  levelReadTrackAction: root + "/Intentionclient/levelReadTrackAction", //主管审阅点评记录->luijng
  levelReplayTrackAction: root + "/Intentionclient/levelReplayTrackAction", //主管回复跟踪记录->ling
  getClientStudentApi: root + "/Client/getClientStudentApi", //招生有效名单->获取可选推荐人-lujing
  getThreeTrackApi: root + "/Client/getThreeTrackApi", //个人详情->获取第三方的外播记录-lujing

  getCrmStudentOneApi: `${root}/CrmStudent/getCrmStudentOneApi`, // 二次招生->获取学生的详细信息-lujing

  getChannelTrack: root + "/Client/getChannelTrack",
  getCrmStuCourseList: root + "/CrmStudent/getCrmStuCourseList",
  getCrmStuClassApi: root + "/CrmStudent/getCrmStuClassApi",
  getStudentTrackListApi: root + "/CrmStudent/getStudentTrackListApi",
  getStudentAuditionListApi: root + "/CrmStudent/getStudentAuditionListApi",
  getStudentInviteListApi: root + "/CrmStudent/getStudentInviteListApi",
  crmTrackStudentAction: root + "/CrmStudent/crmTrackStudentAction",
  getAuditionTypesApi: root + "/Intentionclient/getAuditionTypesApi",
  // 更新电话接通状态
  updateClientAnswerPhoneAction: root + "/Client/updateClientAnswerPhoneAction",
  getInviteGenreApi: root + "/Public/getInviteGenreApi",
  getReMarketerApi: root + "/Public/getReMarketerApi",

  getAuditionOneApi: root + "/Clientinvite/getAuditionOneApi",
  getInviteOneApi: root + "/Clientinvite/getInviteOneApi",
  changeInviteAction: root + "/Clientinvite/changeInviteAction",
  changeIntentionClientOneApi:
    root + "/Intentionclient/changeIntentionClientOneApi",
  addClientOnlyTrackOneApi: root + "/Client/addClientOnlyTrackOneApi",
};
const storeUser = {
  getAuditionOneApi(params) {
    return axios.get(url.getAuditionOneApi, { params });
  },
  getInviteOneApi(params) {
    return axios.get(url.getInviteOneApi, { params });
  },
  changeInviteAction(params) {
    return axios.post(url.changeInviteAction, qs.stringify(params));
  },
  changeIntentionClientOneApi(params) {
    return axios.post(url.changeIntentionClientOneApi, qs.stringify(params));
  },
  addClientOnlyTrackOneApi(params) {
    return axios.post(url.addClientOnlyTrackOneApi, qs.stringify(params));
  },

  //招生有效名单->获取可选推荐人-lujing
  getClientStudentApi(params) {
    return axios.get(url.getClientStudentApi, { params });
  },
  //个人详情->获取第三方的外播记录-lujing
  getThreeTrackApi(params) {
    return axios.get(url.getThreeTrackApi, { params });
  },
  // 获取招生渠道类型
  getSource(params) {
    return axios.get(url.getSource, { params });
  },
  // 获取招生的负责人
  getMarketer(params) {
    return axios.get(url.getMarketer, { params });
  },
  //获取意向课程
  getIntentCourse(params) {
    return axios.get(url.getIntentCourse, { params });
  },
  // 获取单个客户的基本信息
  getclientOne(params) {
    return axios.get(url.getclientOne, { params });
  },
  // 获取单个客户的跟踪记录
  getclientOneTrack(params) {
    return axios.get(url.getclientOneTrack, { params });
  },
  // 获取绑定关系
  getFriendRelation(params) {
    return axios.get(url.getFriendRelation, { params });
  },
  // 获取单个客户的柜询记录-
  getclientOneInvite(params) {
    return axios.get(url.getclientOneInvite, { params });
  },
  // 获取单个客户的试听记录-
  getclientOneAudition(params) {
    return axios.get(url.getclientOneAudition, { params });
  },
  // 招生目标线索->获取单个客户绑定学员
  getBindingClient(params) {
    return axios.get(url.getBindingClient, { params });
  },
  // 获取沟通类型
  getCommode(params) {
    return axios.get(url.getCommode, { params });
  },
  // 获取沟通模板
  getTraceNote(params) {
    return axios.get(url.getTraceNote, { params });
  },
  //获取沟通对象
  getObjectApi(params) {
    return axios.get(url.getObjectApi, { params });
  },
  //接待人->获取有接待权限的接待人
  getReceiverList(params) {
    return axios.get(url.getReceiverList, { params });
  },
  // 绑定学员->获取人员名称
  getClientName(params) {
    return axios.get(url.getClientName, { params });
  },
  // 招生目标线索->跟进客户
  settingtrackClient(params) {
    return axios.post(url.settingtrackClient, qs.stringify(params));
  },
  // 招生目标线索->为客户分配负责人
  addallotClient(params) {
    return axios.post(url.addallotClient, qs.stringify(params));
  },
  // 招生目标线索->绑定学员
  bindingClient(params) {
    return axios.post(url.bindingClient, qs.stringify(params));
  },
  // 主管审阅点评记录->luijng
  levelReadTrackAction(params) {
    return axios.post(url.levelReadTrackAction, qs.stringify(params));
  },
  // 主管回复跟踪记录->ling
  levelReplayTrackAction(params) {
    return axios.post(url.levelReplayTrackAction, qs.stringify(params));
  },
  getCrmStudentOneApi(params) {
    return axios.get(url.getCrmStudentOneApi, {
      params,
    });
  },
  getChannelTrack(params) {
    return axios.get(url.getChannelTrack, {
      params,
    });
  },
  getCrmStuCourseList(params) {
    return axios.get(url.getCrmStuCourseList, {
      params,
    });
  },
  getCrmStuClassApi(params) {
    return axios.get(url.getCrmStuClassApi, {
      params,
    });
  },
  getStudentTrackListApi(params) {
    return axios.get(url.getStudentTrackListApi, {
      params,
    });
  },
  getStudentAuditionListApi(params) {
    return axios.get(url.getStudentAuditionListApi, {
      params,
    });
  },
  getStudentInviteListApi(params) {
    return axios.get(url.getStudentInviteListApi, {
      params,
    });
  },
  crmTrackStudentAction(params) {
    return axios.post(url.crmTrackStudentAction, qs.stringify(params));
  },
  getAuditionTypesApi(params) {
    return axios.get(url.getAuditionTypesApi, {
      params,
    });
  },
  updateClientAnswerPhoneAction(params) {
    return axios.post(url.updateClientAnswerPhoneAction, qs.stringify(params));
  },
  getInviteGenreApi(params) {
    return axios.get(url.getInviteGenreApi, {
      params,
    });
  },
  getReMarketerApi(params) {
    return axios.get(url.getReMarketerApi, {
      params,
    });
  },
};

export default storeUser;
